module.exports = __webpack_public_path__ + "static/media/green-t.ad8d9677.svg";